import {
  useGetAdminDashboardStat,
  useGetCustomerProspect
} from 'common/queries-and-mutations/admin/staff';
import Badge from 'components/Badge';
import AdminStatCard from 'components/Cards/AdminStatCard';
import { Icons } from 'components/Icon';
import Breadcrumb from 'components/Navigation/Breadcrumb';
import React from 'react';
import StaffActivitySummary from './pages/StaffActivitySummary';
import { AccountTypeEnum } from 'apps/user/types/user.enum.type';
import { UserInfoDto } from 'service/dto/user.dto';
import { Link } from 'react-router-dom';
import Chart from 'react-apexcharts';

export default function Dashboard() {
  const { data } = useGetAdminDashboardStat();
  const { data: customers } = useGetCustomerProspect();
  // const [activeIndex, setActiveIndex] = useState(0);

  const getCustomerStatus = (
    user: UserInfoDto
  ): { label: string; type: 'default' | 'success' | 'warning' | 'danger' } => {
    if (!user.isActive) {
      return {
        label: 'In Active',
        type: 'danger'
      };
    }
    if (!user.isStepCompleted) {
      return {
        label: 'Pending',
        type: 'danger'
      };
    }
    if (user.sentForApproval && user.isAccountLocked) {
      return {
        label: 'Awaiting Approval',
        type: 'default'
      };
    }
    if (user.isAccountLocked && !user.isActive) {
      return {
        label: 'Completed',
        type: 'success'
      };
    }
    if (user.isStepCompleted && user.isAccountLocked && user.isActive) {
      return {
        label: 'Awaiting Signing',
        type: 'warning'
      };
    }

    return {
      label: 'In Progress',
      type: 'default'
    };
  };

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     const newIndex = (activeIndex + 1) % [].length;
  //     setActiveIndex(newIndex);

  //   }, 5000)
  // }, [])

  return (
    <div>
      <Breadcrumb title="Your Dashboard Today" />
      <div className="my-5 grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-4">
        <div className="col-span-12 flex space-x-5 overflow-x-auto px-[var(--margin-x)] transition-all duration-[.25s] scrollbar-hide">
          <AdminStatCard
            name={'Customers'}
            count={data?.totalCustomer ?? 0}
            icon={Icons.Customer}
          />
          <AdminStatCard
            name={'Prospects'}
            count={data?.totalProspect ?? 0}
            icon={Icons.Prospect}
          />
          <AdminStatCard
            name={'Wills Completed'}
            count={data?.totalCompletedWill ?? 0}
            icon={Icons.iWillCompleted}
          />
          <AdminStatCard
            name={'Pending Wills'}
            count={data?.totalPendingWill ?? 0}
            icon={Icons.iWillPending}
          />
        </div>
      </div>
      <div className="mt-3">
        <div className="grid grid-cols-12 gap-5">
          <div className="col-span-12 w-full lg:col-span-8">
            <div className="relative min-h-[21.8rem] overflow-x-auto bg-white sm:rounded-lg">
              <div className="mb-3 flex items-center justify-between">
                <div className="p-5 text-left text-lg font-semibold text-gray-900">
                  List
                </div>
              </div>
              <div className="flex flex-col items-center justify-center">
                <table className="my-[1rem] w-full text-left text-sm">
                  <thead className="border-b bg-white text-xs text-[#1F4173]">
                    <tr>
                      <th scope="col" className="px-6 py-3">
                        Name
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Email
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Type
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Status
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody className="px-6 py-4">
                    {!customers || customers.length < 1 ? (
                      <tr className="text-center">
                        <td colSpan={5} className="py-10 text-lg">
                          No results found
                        </td>
                      </tr>
                    ) : (
                      customers.map(customer => (
                        <tr
                          key={customer.id}
                          className="border-b bg-white hover:bg-gray-50"
                        >
                          <td className="px-6 py-4 text-xs font-normal  text-[#353535]">
                            {`${customer.othername} ${customer.surname}`}
                          </td>
                          <td className="px-6 py-4 text-xs font-normal text-[#353535]">
                            {customer.email}
                          </td>
                          <td className="px-6 py-4 text-xs font-normal text-[#353535]">
                            {customer.accountType === AccountTypeEnum.CLIENT
                              ? 'Customer'
                              : 'Prospect'}
                          </td>
                          <td className="px-6 py-4 text-xs font-normal text-[#353535]">
                            <Badge
                              size="sm"
                              title={getCustomerStatus(customer).label}
                              type={getCustomerStatus(customer).type}
                              className="w-[9rem]"
                            />
                          </td>
                          <td className="px-6 py-4 text-xs font-normal text-[#353535]">
                            <Link
                              to={`/admin/customers/details/${customer.id}`}
                              className="rounded-md bg-primary-900 p-2 px-5 text-white underline"
                            >
                              View
                            </Link>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="col-span-12 w-full lg:col-span-4">
            <div className="w-full rounded-lg bg-white">
              <p className="p-5 text-sm font-semibold text-[#353535]">
                Customer Completion
              </p>
              {/* <div className="flex items-center justify-center">
                <div className="flex flex-col items-center justify-center">
                  <div className="flex items-center">
                    <div className="z-10s flex h-[13rem] w-[13rem] shrink-0 items-center justify-center rounded-full bg-[#FF6600]">
                      <div className="flex h-40 w-40 items-center justify-center rounded-full bg-white">
                        <div className="flex h-20 w-20 items-center justify-center rounded-full bg-white text-center shadow-2xl">
                          <p className="text-2xl text-[#353535]">N/A</p>
                        </div>
                      </div>
                    </div>
                    <div className="flex h-0.5 w-full bg-gray-200 dark:bg-gray-700"></div>
                  </div>
                </div>
              </div> */}
              <div className="px-5 pb-14"></div>
              <Chart
                type="donut"
                width={439}
                height={245}
                series={[
                  data?.totalCustomer ?? 0,
                  data?.totalCompletedWill ?? 0
                ]}
                options={{
                  responsive: [
                    {
                      breakpoint: undefined,
                      options: {}
                    }
                  ],
                  labels: ['Customer', 'Completed'],
                  colors: ['#C6C6C6', '#00B388'],
                  plotOptions: {
                    pie: {
                      expandOnClick: true,
                      startAngle: 0,
                      offsetX: 0,
                      offsetY: 0,
                      customScale: 1,
                      dataLabels: {
                        offset: 0,
                        minAngleToShowLabel: 10
                      },
                      donut: {
                        labels: {
                          show: true,
                          name: {
                            show: false
                          },
                          total: {
                            show: true,
                            showAlways: true,
                            // fontSize: 30,
                            color: '#373d3f',
                            fontWeight: 700,
                            // formatter: (w: {
                            //   globals: { seriesTotals: any[] };
                            // }) => {
                            //   const total = w.globals.seriesTotals.reduce(
                            //     (a: any, b: any) => {
                            //       return a + b;
                            //     },
                            //     0
                            //   );
                            //   console.log('🚀 ~ Dashboard ~ total:', total);
                            //   return total / 2 + '%';
                            //   // return (data?.totalCustomer ?? 0) / (data?.totalCompletedWill ?? 0) + '%'
                            //   // return 40 + '%';
                            // }
                            formatter: function (w: {
                              globals: { seriesTotals: any[] };
                            }) {
                              const total = w.globals.seriesTotals.reduce(
                                (a: any, b: any) => {
                                  return a + b;
                                },
                                0
                              );
                              return (
                                (total / w.globals.seriesTotals.length).toFixed(
                                  1
                                ) + '%'
                              );
                            }
                          }
                        }
                      }
                    }
                  },
                  legend: {
                    position: 'bottom',
                    horizontalAlign: 'center'
                  },
                  dataLabels: {
                    formatter: function (val: number) {
                      return val / 1 + '%';
                    },
                    enabled: false
                  }
                }}
              />
              <div className="px-5 pb-16"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-3">
        <div className="grid grid-cols-12 gap-5">
          <div className="col-span-12 w-full">
            <StaffActivitySummary />
          </div>
        </div>
      </div>
    </div>
  );
}
